import { by, get } from '@services/custom.service'
import { BaseService } from '@services/base.service'
import { TENNAT_API_URL } from '@services/.env'

export default class LayoutService extends BaseService {
  static getCampusList(data) {
    return new Promise((resolve, reject) => {
      return by(`${TENNAT_API_URL}user/campuses`, data)
        .then((response) => {
          resolve(this.responseWrapper(response, response.data))
        })
        .catch((error) => {
          const message = 'Could not get campuse list'
          reject(this.errorWrapper(error, message))
        })
    })
  }

  static getUserSpecificSectionsList(data) {
    return new Promise((resolve, reject) => {
      return by(`${TENNAT_API_URL}sections/user_specific`, data)
        .then((response) => {
          resolve(this.responseWrapper(response, response.data))
        })
        .catch((error) => {
          const message = 'Could not get Class list'
          reject(this.errorWrapper(error, message))
        })
    })
  }
  static getActiveGuardianStudents() {
    return new Promise((resolve, reject) => {
      return by(`${TENNAT_API_URL}guardian/students`)
        .then((response) => {
          resolve(this.responseWrapper(response, response.data))
        })
        .catch((error) => {
          const message = 'Could not get students'
          reject(this.errorWrapper(error, message))
        })
    })
  }
  static setDisabledFeatures(payload, commit) {
    return new Promise((resolve, reject) => {
      return by(`${TENNAT_API_URL}feature_managements`, payload)
        .then((response) => {
          resolve(this.responseWrapper(response, response.data))
        })
        .catch((error) => {
          reject(this.errorWrapper(error, error.message))
        })
    })
  }
  static getDisabledFeatures(commit) {
    return new Promise((resolve, reject) => {
      return get(`${TENNAT_API_URL}feature_managements`)
        .then((response) => {
          resolve(this.responseWrapper(response, response.data))
        })
        .catch((error) => {
          reject(this.errorWrapper(error, error.message))
        })
    })
  }
  static setUserNotificationPreferences(payload, commit) {
    return new Promise((resolve, reject) => {
      return by(`${TENNAT_API_URL}user_notification_preferences`, payload)
        .then((response) => {
          resolve(this.responseWrapper(response, response.data))
        })
        .catch((error) => {
          reject(this.errorWrapper(error, error.message))
        })
    })
  }
  static getUserNotificationPreferences(commit) {
    return new Promise((resolve, reject) => {
      return get(`${TENNAT_API_URL}user_notification_preferences`)
        .then((response) => {
          resolve(this.responseWrapper(response, response.data))
        })
        .catch((error) => {
          reject(this.errorWrapper(error, error.message))
        })
    })
  }
}
